import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';

import { Sede } from '../shared/models/sede';
import { Asignacion } from '../shared/models/asignacion';
import { ListaItem } from '../shared/models/lista-item';
import { Vlan } from '../shared/models/vlan';
import { ExportarExcelAsignacionesDto } from '../shared/models/exportar-asignaciones-dto';
import { ParametrosConsultarAsignacion } from '../shared/models/parametros-consultar-asignacion';
import { SedeService } from '../shared/services/sede.service';
import { ListaItemService } from '../shared/services/lista-item.service';
import { VlanService } from '../shared/services/vlan.service';
import { AdministradorIpService } from '../shared/services/administrador-ip.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-consultar-asignaciones',
  templateUrl: './consultar-asignaciones.component.html',
  styleUrls: ['./consultar-asignaciones.component.css']
})
export class ConsultarAsignacionesComponent implements OnInit {
  parametrosFormGoup = this.formBuilder.group({
    urlControl: new FormControl(),
    servidorControl: new FormControl(),
    plataformaControl: new FormControl(),
    rolControl: new FormControl(),
    direccionControl: new FormControl(),
    sedeControl: new FormControl(),
    vlanControl: new FormControl(),
    usuarioControl: new FormControl(),
  });

  private codigoListaUrl = environment.listaCodigoUrl;
  private codigoListaServidor = environment.listaCodigoServidor;
  private codigoListaServicio = environment.listaCodigoServicio;
  private codigoListaPlataforma = environment.listaCodigoPlataforma;
  private codigoListaRol = environment.listaCodigoRol;

  MENSAJE_DILIGENCIE_PARAMETRO = 'Debes diligenciar al menos un parametro';

  urls: ListaItem[] = new Array<ListaItem>();
  urlsFiltradas: ListaItem[] = new Array<ListaItem>();
  urlSeleccionado: ListaItem = new ListaItem();
  servidores: ListaItem[] = new Array<ListaItem>();
  servidoresFiltrados: ListaItem[] = new Array<ListaItem>();
  servidorSeleccionado: ListaItem = new ListaItem();
  plataformas: ListaItem[] = new Array<ListaItem>();
  plataformaFiltradas: ListaItem[] = new Array<ListaItem>();
  plataformaSeleccionado: ListaItem = new ListaItem();
  roles: ListaItem[] = new Array<ListaItem>();
  rolesFiltrados: ListaItem[] = new Array<ListaItem>();
  rolSeleccionado: ListaItem = new ListaItem();
  vlans: Vlan[] = new Array<Vlan>();
  vlansFiltradas: Vlan[] = new Array<Vlan>();
  vlanSeleccionada: Vlan = new Vlan();
  usuario: string = null;
  direccionIp: string = null;
  sedes: Sede[] = new Array<Sede>();
  sedeSeleccionada: Sede = new Sede();
  asignaciones: Asignacion[] = new Array<Asignacion>();
  parametros: ParametrosConsultarAsignacion;
  modalRef: NgbModalRef;
  mensajeAlerta = '';
  listaDtoExportar: ExportarExcelAsignacionesDto[] = new Array<ExportarExcelAsignacionesDto>();
  @ViewChild('downloadZipLink') private downloadZipLink: ElementRef;

  constructor(private sedeService: SedeService, private vlanService: VlanService,
  private listaItemService: ListaItemService,
  private administradorIpService: AdministradorIpService,
  private formBuilder: FormBuilder,
  private modalService: NgbModal) { }

  ngOnInit() {
    this.ListarServidor();
    this.ListarUrl();
    this.ListarPlataformas();
    this.ListarRoles();
    this.listarVlans();
    this.listarSedes();
  }

  // Carga la lista completa de urls disponibles
  public ListarUrl(): void {
    this.listaItemService.listaItemsPorCodigoLista(this.codigoListaUrl).subscribe(
      resultado => this.urls = resultado
    );
  }

  // Carga la lista completa de servidores disponibles
  public ListarServidor(): void {
    this.listaItemService.listaItemsPorCodigoLista(this.codigoListaServidor).subscribe(
      resultado => this.servidores = resultado
    );
  }

  // Carga la lista completa de plataformas disponibles
  public ListarPlataformas(): void {
    this.listaItemService.listaItemsPorCodigoLista(this.codigoListaPlataforma).subscribe(
      resultado => this.plataformas = resultado
    );
  }

  // Carga la lista completa de roles disponibles
  public ListarRoles(): void {
    this.listaItemService.listaItemsPorCodigoLista(this.codigoListaRol).subscribe(
      resultado => this.roles = resultado
    );
  }

  // Carga la lista de vlans disponibles
  public listarVlans(): void {
    this.vlanService.vlansActivas().subscribe(
      resultado => this.vlans = resultado
    );
  }

  // Carga la lista de sedes disponibles
  public listarSedes(): void {
    this.sedeService.listarSedes().subscribe(
      resultado => this.sedes = resultado
    );
  }

  // Metodo que consulta a medida que el usuario escribe en el campo servidor
  // En caso de no encontrar un valor corresponiendte lo settea como una lista nueva
  public filterServidor(event) {
    this.servidoresFiltrados = [];
    for (let i = 0; i < this.servidores.length; i++) {
      const servidor = this.servidores[i];
      if (servidor.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.servidoresFiltrados.push(servidor);
      }
    }
  }

  // Metodo que consulta a medida que el usuario escribe en el campo url
  // En caso de no encontrar un valor corresponiendte lo settea como una lista nueva
  filterUrl(event) {
    this.urlsFiltradas = [];
    for (let i = 0; i < this.urls.length; i++) {
      const url = this.urls[i];
      if (url.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.urlsFiltradas.push(url);
      }
    }
  }

  // Metodo que consulta a medida que el usuario escribe en el campo plataforma
  // En caso de no encontrar un valor corresponiendte lo settea como una lista nueva
  filterPlataforma(event) {
    this.plataformaFiltradas = [];
    for (let i = 0; i < this.plataformas.length; i++) {
      const plataforma = this.plataformas[i];
      if (plataforma.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.plataformaFiltradas.push(plataforma);
      }
    }
  }

  // Metodo que consulta a medida que el usuario escribe en el campo rol
  // En caso de no encontrar un valor corresponiendte lo settea como una lista nueva
  filterRol(event) {
    this.rolesFiltrados = [];
    for (let i = 0; i < this.roles.length; i++) {
      const rol = this.roles[i];
      if (rol.valorItem.toUpperCase().indexOf(event.query.toUpperCase()) >= 0) {
        this.rolesFiltrados.push(rol);
      }
    }
  }

  // Metodo que consulta a medida que el usuario escribe en el campo vlan
  // En caso de no encontrar un valor corresponiendte lo settea como una lista nueva
  filterVlan(event) {
    this.vlansFiltradas = [];
    for (let i = 0; i < this.vlans.length; i++) {
      const vlan = this.vlans[i];
      if (vlan.nombreVlan.toUpperCase().indexOf(event.query.toUpperCase()) >= 0 ) {
        this.vlansFiltradas.push(vlan);
      }
    }
  }


  // Metodo que trae las asignaciones segun los parametros seleccionados
  consultarAsignaciones(cargandoModal, alertaModal): void {
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
    if (this.validarParametros()) {
      this.administradorIpService.consultarAsignacionesByParametros(this.parametros).subscribe(
          resultado => {
            this.asignaciones = resultado;
            this.modalRef.close();
          }
        );
    } else {
      this.modalRef.close();
      this.mensajeAlerta = this.MENSAJE_DILIGENCIE_PARAMETRO;
      this.modalRef = this.modalService.open(alertaModal, {size: 'lg'});
    }

  }

  // Metodo que valida los valores ingresados en los parametros
  validarParametros(): boolean {
    this.parametros = new ParametrosConsultarAsignacion();
    let indParametros = false;
    if (this.servidorSeleccionado.idListaItem != null) {
      indParametros = true;
      this.parametros.idServidor = this.servidorSeleccionado.idListaItem;
    } else {
      this.parametros.idServidor = null;
    }

    if (this.direccionIp != null) {
      indParametros = true;
      this.parametros.direccionIp = this.direccionIp;
    } else {
      this.parametros.direccionIp = null;
    }

    if (this.urlSeleccionado.idListaItem != null) {
      indParametros = true;
      this.parametros.idUrl = this.urlSeleccionado.idListaItem;
    } else {
      this.parametros.idUrl = null;
    }

    if (this.sedeSeleccionada.idSede != null) {
      indParametros = true;
      this.parametros.idSede = this.sedeSeleccionada.idSede;
    } else {
      this.parametros.idSede = null;
    }

    if (this.plataformaSeleccionado.idListaItem != null) {
      indParametros = true;
      this.parametros.idPlataforma = this.plataformaSeleccionado.idListaItem;
    } else {
      this.parametros.idPlataforma = null;
    }

    if (this.rolSeleccionado.idListaItem != null) {
      indParametros = true;
      this.parametros.idRol = this.rolSeleccionado.idListaItem;
    } else {
      this.parametros.idRol = null;
    }

    if (this.vlanSeleccionada.idVlan != null) {
      indParametros = true;
      this.parametros.idVlan = this.vlanSeleccionada.idVlan;
    } else {
      this.parametros.idVlan = null;
    }

    if (this.usuario != null) {
      indParametros = true;
      this.parametros.nombreUsuario = this.usuario;
    } else {
      this.parametros.nombreUsuario = null;
    }
    return indParametros;
  }

  // Metodo que exporta en excel los resultados de la consulta de asignaciones
  public async exportarAsignaciones(cargandoModal): Promise<void> {
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
    this.armarListaExportar();
    const blob = await this.administradorIpService.exportarAsignaciones(this.listaDtoExportar);
    const url = window.URL.createObjectURL(blob);

    const link = this.downloadZipLink.nativeElement;
    link.href = url;
    link.download = 'Asignaciones.xls';
    link.click();
    window.URL.revokeObjectURL(url);
    this.modalRef.close();
  }

  // Setea la lista en el dto que se exporta en excel
  public armarListaExportar(): void {
    this.listaDtoExportar = new Array<ExportarExcelAsignacionesDto>();
    for (let i = 0; i < this.asignaciones.length; i++) {
      const exportarDto = new ExportarExcelAsignacionesDto();
      exportarDto.ambiente = this.asignaciones[i].direccionIp.vlan.ambiente.valorItem;
      exportarDto.direccionIp = this.asignaciones[i].direccionIp.direccion;
      exportarDto.plataforma = this.asignaciones[i].plataforma.valorItem;
      exportarDto.rol = this.asignaciones[i].funcion.valorItem;
      exportarDto.sede = this.asignaciones[i].direccionIp.vlan.sede.nombreSede;
      exportarDto.servidor = this.asignaciones[i].nombreServidor.valorItem;
      exportarDto.compania = this.asignaciones[i].compania.nombreCompania;
      exportarDto.ciudad = this.asignaciones[i].direccionIp.vlan.sede.ciudad.nombreCiudad;
      exportarDto.servicio = this.asignaciones[i].servicioITNegocio.valorItem;
      exportarDto.fechaSolicita = this.asignaciones[i].fechaCreacion;
      exportarDto.usuarioSolicita = this.asignaciones[i].usuarioCrea;
      if (this.asignaciones[i].nombreURL != null) {
          exportarDto.url = this.asignaciones[i].nombreURL.valorItem;
      } else {
          exportarDto.url = '';
      }
      exportarDto.observaciones = this.asignaciones[i].observaciones;
      this.listaDtoExportar.push(exportarDto);
    }
  }

  // Metodo que limpia los controles
  public limpiarPantalla(): void {
    this.asignaciones = new Array<Asignacion>();
    this.servidorSeleccionado = new ListaItem();
    this.direccionIp = null;
    this.urlSeleccionado = new ListaItem();
    this.sedeSeleccionada = new Sede();
    this.plataformaSeleccionado = new ListaItem();
    this.rolSeleccionado = new ListaItem();
    this.vlanSeleccionada = new Vlan();
    this.usuario = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/consultar-asignaciones/consultar-asignaciones.component.ts